<script lang="ts" setup>
import BaseSubContent from "@/components/BaseSubContent.vue";
import CharacterSkillEffect from "@/components/CharacterSkillEffect.vue";

const props = defineProps<{
    effects: SkillEffect[];
}>();
</script>

<template>
    <BaseSubContent :header="`Effect${effects.length > 1 ? 's' : ''}`">
        <ul class="ml-4 list-disc">
            <li v-for="effect in effects">
                <CharacterSkillEffect :effect="effect" />
            </li>
        </ul>
    </BaseSubContent>
</template>

<style scoped></style>
